import React, { useCallback, useState } from "react"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from '~/ui/styled'
import LinearGradient from '~/ui/LinearGradient'
import { StartFlex, ColumnFlex, CenterFlex, BetweenFlex, IconFont, Text, Button } from "~components/El"
import QrCodeCard from "~components/qrcode-card"
import useNavigation from "~hooks/useNavigation"
import { useStores } from "~models"
import { Avatar } from "~widgets/avatar"
import { usePopup } from "~hooks/usePopup"
import { copyText } from "~utils"

const LinearGradientContainer = styled(LinearGradient)`
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
`

const RefreshIconWrap = styled.span<{ $spinning: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  animation: ${({ $spinning }) => ($spinning ? "el-spin 0.8s linear infinite" : "none")};
`
type  ProfileProps = {
  onClick?: (type?: string) => void
}
const Profile: React.FC<ProfileProps> = ({ onClick }) => {
  const theme = useTheme()
  const popup = usePopup()
  const navigation = useNavigation()
  const { userStore: { currentUser }, walletStore } = useStores()
  const [loading, setLoading] = useState(false)

  const handlePress = useCallback(() => {
    navigation.push("BasicInfo")
  }, [navigation])

  const handleRefresh = async () => {
    if (loading) return

    setLoading(true)
    try {
      await walletStore.getWalletInfo()
    } finally {
      setLoading(false)
    }
  }

  const openQrcodeModal = useCallback(() => {
    popup.open({
      type: "center",
      width: "100%",
      content: () => React.createElement(QrCodeCard, { user: currentUser }),
    })
  }, [currentUser, popup])

  if (!currentUser) {
    return null
  }

  return (
    <StartFlex width="100%" height="auto" padding="12px">
        <LinearGradientContainer
          colors={['#07c160', '#406df4', '#07c160']}
          // locations={[0, 0.5, 1]}
          start={{ x: 0.1, y: 0 }}
          end={{ x: 1, y: 1 }}
        >
        <ColumnFlex width="100%" padding="16px">
          <BetweenFlex width="100%">
            <StartFlex>
              <Button width="auto" height="auto" onClick={handlePress}>
                <Avatar
                  size={60}
                  avatar={currentUser.avatar}
                  name={currentUser.name}
                />
              </Button>
              <ColumnFlex ml="10px">
                <Button flexDirection="row" padding="3px 0" onClick={handlePress}>
                  <Text fontSize={theme.fontSizes.xl} color={theme.colors.textLight} mr="10px">{currentUser.name}</Text>
                  <IconFont name="bbj" size={12} color={theme.colors.textLight} />
                </Button>
                <Button flexDirection="row" padding="3px 0" onClick={() => copyText(currentUser.username)}>
                  <Text fontSize={theme.fontSizes.sm} color={theme.colors.border} mr="10px">ID: {currentUser.username}</Text>
                  <IconFont name="copy" size={12} color={theme.colors.border} />
                </Button>
              </ColumnFlex>
            </StartFlex>
            <Button width="auto" height="auto" onClick={openQrcodeModal}>
              <IconFont name="ewm" size={24} color={theme.colors.textLight} />
            </Button>
          </BetweenFlex>
          <BetweenFlex width="100%" padding="20px 0">
            <Button flexDirection="row" onClick={() => walletStore.setEncryptedBalance(!walletStore?.isEncryptedBalance)}>
              <Text fontSize={theme.fontSizes.lg} color={theme.colors.textLight} mr="10px">钱包余额</Text>
              <IconFont name={walletStore?.isEncryptedBalance ? "yincang" : "xszxzt"} size={14} color={theme.colors.textLight} />
            </Button>
            <Button flexDirection="row" onClick={handleRefresh}>
              <Text fontSize={theme.fontSizes.lg} color={theme.colors.textLight} mr="5px">¥{walletStore?.isEncryptedBalance ? "****" : (walletStore?.balance || 0)}</Text>
              <RefreshIconWrap $spinning={loading}>
                <IconFont name="sx" size={14} color={theme.colors.textLight} />
              </RefreshIconWrap>
            </Button>
          </BetweenFlex>
          <BetweenFlex width="100%">
            <Button
              flexDirection="row"
              width="31%"
              height="40px"
              borderRadius="8px"
              bg={theme.colors.blockBackground}
              onClick={() => onClick('RECHARGE')}
            >
              <CenterFlex
                width="20px"
                height="20px"
                borderRadius="10px"
                bg="rgba(7, 193, 96, 0.1)"
              >
                <IconFont name="cz" size={12} color={theme.colors.primary} />
              </CenterFlex>
              <Text fontSize={theme.fontSizes.lg} color={theme.colors.primary} fontWeight="600" ml="8px">充值</Text>
            </Button>
            <Button
              flexDirection="row"
              width="31%"
              height="40px"
              borderRadius="8px"
              bg={theme.colors.blockBackground}
              onClick={() => onClick('WITHDRAW')}
            >
              <CenterFlex
                width="20px"
                height="20px"
                borderRadius="10px"
                bg="rgba(250, 126, 81, 0.1)"
              >
                <IconFont name="ty1" size={12} color={theme.colors.warningText} />
              </CenterFlex>
              <Text fontSize={theme.fontSizes.lg} color={theme.colors.warningText} fontWeight="600" ml="8px">提现</Text>
            </Button>
            <Button
              flexDirection="row"
              width="31%"
              height="40px"
              borderRadius="8px"
              bg={theme.colors.blockBackground}
              onClick={() => onClick('BILL')}
            >
              <CenterFlex
                width="20px"
                height="20px"
                borderRadius="10px"
                bg="rgba(78, 152, 243, 0.1)"
              >
                <IconFont name="d" size={12} color={theme.colors.primaryText} />
              </CenterFlex>
              <Text fontSize={theme.fontSizes.lg} color={theme.colors.primaryText} fontWeight="600" ml="8px">账单</Text>
            </Button>
          </BetweenFlex>
        </ColumnFlex>
      </LinearGradientContainer>
    </StartFlex>
    
  )
}
export default observer(Profile)
